import { useContext, useEffect, useState } from "react";

import { LangContext } from "../../context/LangContext";
import { useFormatText } from '../../hooks/useFormatText';

import SelectLang from '../../components/SelectLang';
import Slider from '../../components/Slider';
import Onglet from "../../components/Onglet";

import "./style.css"


function VanRah() {
    const formatText = useFormatText();
    const [vanrahData, setVanrahData] = useState(null);
    const { language, translations } = useContext(LangContext);

    useEffect(() => {
        localStorage.setItem('opt_return_work_pg_vanrah', 'vanrah');
        fetch(`${process.env.REACT_APP_API_URL}/vanrah/view`, { method: 'POST' });

        const fetchVanrahData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/vanrah/profile`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);

            setVanrahData({
                logo: res.logo || null,
                descrip_fr: res.descrip_fr || '',
                descrip_en: res.descrip_en || '',
                images: res.images || [],
                series: res.series || [],
                video: res.video || '',
            });
        }
        fetchVanrahData();
    }, []);

    const getPath = (work) => {
        const page_path = work.type === 1 ? 'mangas' : 'works';
        return `${page_path}/${work.title_path}`;
    }

    return vanrahData && (
        <div className='page page_vanrah'>
            <SelectLang />

            <section className="sect_presentation">
                <Slider images={vanrahData.images} />

                <div className="description">
                    <p className="title_page">
                        - <span>VanRah</span> -
                    </p>

                    <div
                        className="logo"
                        style={{ backgroundImage: `url(${vanrahData?.logo.url})` }}
                    ></div>

                    <div className="textarea">
                        <span className="label">{translations.detail_and_descrip} :</span>
                        <p className="value">{formatText(vanrahData[`descrip_${language}`])}</p>
                    </div>
                </div>
            </section>

            <section className="sect_published_series">
                <p className="subtitle_page">
                    - <span>{translations.published_series}</span> -
                </p>

                <ul className="published_series_list">
                    {vanrahData.series && vanrahData.series.map((work, idx) => (
                        <li key={idx} className="li_serie">
                            <Onglet data={work} idx={idx} getPath={getPath} />
                        </li>
                    ))}
                </ul>
            </section>

            <section className="sect_artist_univers">
                <p className="subtitle_page">
                    - <span>{translations.discover_artist}</span> -
                </p>

                <div className="video">
                    <iframe
                        title="video"
                        src={vanrahData.video}

                        width="100%"
                        height="100%"

                        frameBorder="0"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>
        </div>
    )
}

export default VanRah;